<template>
  <div id="activityInfo">
    <crumbs title="活动数据管理" />
    <div class="content mt-20">
      <el-form
        :model="form"
        :rules="rules"
        ref="ruleForm"
        label-position="right"
        label-width="120px"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="活动标题：" prop="AcTitle">
              <el-input
                v-model="form.AcTitle"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="活动副标题：">
              <el-input
                v-model="form.AcSubTitle"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="活动来源：" prop="AcSource">
              <el-input
                v-model="form.AcSource"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="活动类型：">
              <activity-type v-model="form.AcType" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="活动图片：" prop="fileList" required>
          <image-upload
            url="/api/activity/uploadimg"
            accept="image/jpeg,image/png"
            :size-limit="3"
            :num-limit="1"
            :file-list.sync="form.fileList"
          />
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="发布时间：" prop="PublishDate">
              <el-date-picker
                v-model="form.PublishDate"
                type="datetime"
                placeholder="选择日期时间"
                format="yyyy-MM-dd HH:mm:ss"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="是否推荐：" prop="IsShow">
              <el-switch
                v-model="form.IsShow"
                active-color="#13ce66"
                inactive-color="#dcdfe6"
                :active-value="1"
                :inactive-value="0"
              >
              </el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="活动标签：">
              <el-input
                v-model="form.AcTag"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="SEO关键字：">
          <el-input v-model="form.SEOKey" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="SEO描述：">
          <el-input
            type="textarea"
            v-model="form.SEODescription"
            :autosize="{ minRows: 3 }"
            placeholder="请输入内容"
            show-word-limit
            resize="none"
          ></el-input>
        </el-form-item>
        <el-form-item label="活动内容：" prop="AcContent">
          <tinymce-editor v-model="form.AcContent" />
        </el-form-item>
        <el-row class="flush-center">
          <template v-if="isAdd">
            <el-button type="primary" plain @click="handlerAddData('ruleForm')"
              >保存</el-button
            >
          </template>
          <template v-else>
            <el-button type="primary" @click="handlerModifyData('ruleForm')"
              >修改</el-button
            >
          </template>
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
import Crumbs from "./component/crumbs";
import ActivityType from "./component/activityType";
import ImageUpload from "./component/imageUpload";
import TinymceEditor from "./component/editor";
export default {
  name: "activityInfo",
  created() {
    const { type } = this.$route.params;
    if (type === "modification") {
      this.isAdd = false;
      this.loadCompanyInfo();
    }
  },
  data() {
    const isEmpty = {
      required: true,
      message: "该项值不能为空",
      trigger: ["blur", "change"]
    };
    return {
      isAdd: true,
      form: {
        AcTitle: "",
        AcSubTitle: "",
        AcType: "",
        AcSource: "",
        PublishDate: new Date(),
        IsShow: 1,
        AcTag: "",
        SEOKey: "",
        SEODescription: "",
        AcContent: "",
        //上传的图片列表
        fileList: [
          // {
          //   name: "food.jpeg",
          //   url:
          //     "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100"
          // }
        ]
      },
      rules: {
        AcTitle: [isEmpty],
        AcSource: [isEmpty],
        PublishDate: [isEmpty],
        IsShow: [isEmpty],
        AcContent: [isEmpty],
        fileList: [
          {
            validator: (rule, value) => {
              return new Promise((resolve, reject) => {
                if (value.length > 0) {
                  return resolve();
                } else {
                  reject("必须上传活动图片");
                }
              });
            }
          }
        ]
      }
    };
  },
  methods: {
    //正向处理数据 将数据处理后提交
    processDataSubmit() {
      const obj = {
        AcType: this.form.AcType === "" ? -1 : this.form.AcType,
        ImgUrl: this.form.fileList[0].url
      };
      const res = {
        ...this.form,
        ...obj
      };
      delete res.fileList;
      return res;
    },
    //逆向处理数据 获取后进行数据处理回显
    downloadProcessData(data) {
      let res = {},
        obj = {
          AcType: data.AcType === -1 ? "" : data.AcType,
          fileList: [
            {
              url: data.ImgUrl
            }
          ]
        };
      Object.keys(this.form).map(item => {
        if (data[item] !== undefined) {
          res[item] = data[item];
        }
      });
      this.form = {
        ...res,
        ...obj
      };
    },
    //点击添加数据按钮
    handlerAddData(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loadAddData();
        }
      });
    },
    //加载添加数据接口
    loadAddData() {
      const params = this.processDataSubmit();
      this.requestApi("activity", "addData", params, res => {
        this.$message({
          message: res.Message,
          type: res.Code === 0 ? "success" : "error"
        });
        if (res.Code === 0) {
          this.redirectTo();
        }
      });
    },
    //点击修改数据按钮
    handlerModifyData(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loadModifyData();
        }
      });
    },
    //加载修改数据接口
    loadModifyData() {
      const { Id } = this.$route.query;
      const params = this.processDataSubmit();
      this.requestApi("activity", "modifyData", { ...params, Id }, res => {
        this.$message({
          message: res.Message,
          type: res.Code === 0 ? "success" : "error"
        });
        if (res.Code === 0) {
          this.redirectTo();
        }
      });
    },
    //加载数据接口
    loadCompanyInfo() {
      const { Id } = this.$route.query;
      this.requestApi("activity", "getActivityInfo", { Id }, res => {
        const { Code, Message } = res;
        if (Code === 0) {
          this.downloadProcessData(res.ActivityList[0]);
        } else {
          this.$message.error(Message);
          this.redirectTo();
        }
      });
    },
    //返回列表页
    redirectTo() {
      this.redirectByPath("/activityList");
    }
  },
  watch: {
    "form.fileList": function(value, oldvalue) {
      setTimeout(() => {
        this.$refs.ruleForm.validateField("fileList");
      }, 0);
    }
  },
  components: {
    Crumbs,
    ImageUpload,
    ActivityType,
    TinymceEditor
  }
};
</script>

<style lang="less">
#activityInfo {
  .content {
    padding: 20px 50px;
    background: #fff;
  }
}
</style>
